import React from "react";
import TitleBlock from "../TitleBlock";
import SettingsTopRow from "./SettingsTopRow";

const AccountSettingsMobileHeader = () => {
  return (
    <div>
      <SettingsTopRow />
      <TitleBlock
        title="Account Settings"
        subtitle="It's all the little things that matter here."
      />
    </div>
  );
};

export default AccountSettingsMobileHeader;
